/**
* @Description: 语法学习-课程-公共部分
* @author Wangshu
* @date 2020-04-08
*/
<template>
  <div>
    <div class="text-book" style="margin-top: 10px;">
      <div class="title">{{courseInfo.curriculum_id_name}}</div>
      <div class="title-text">语法基础：以语法为核心，对语法，句子等进行基础与提高学习，并且可就全书范围进行智能听写。</div>
    </div>
    <div class="text-book">
      <div class="title">综合学习</div>
      <div class="class-btn">
        <el-button size="small" type="primary" @click="startAIListen()">智能听写</el-button>
        <el-button size="small" type="danger" @click="startComparision()">对比测试</el-button>
        <el-button size="small" type="warning" @click="preciseReview()">精准复习</el-button>
        <el-button size="small" type="success" @click="checkUnitEnd()" style="position: relative;">
          本书测试
          <transition name="el-zoom-in-center">
            <div class="lock-unit" v-if="showBookPop">还未学完该教材</div>
          </transition>
        </el-button>
      </div>
    </div>
    <div class="menu-link">
      <div
        class="title"
        :class="{'active-item': item.type==$route.query.type}"
        v-for="(item,index) in menuLink"
        @click="goLink(item)"
        :key="'a-'+index"
      >{{item.name}}</div>
    </div>
    <transition name="el-fade-in" mode="out-in">
      <router-view></router-view>
    </transition>
    <dynamic-box
      :windowStatus="windowStatus"
      :data="studyStage.dataSource"
      :type="studyStage.type"
      @callBack="callBack"
    ></dynamic-box>
  </div>
</template>

<script>
import Lockr from "lockr";
import dynamicBox from "../templates/dynamicBox";
import { mapState, mapGetters, mapMutations } from "vuex";
import {
  intelligentDictation,
  reviewNum,
  preciseIntelligentReview,
  checkBook,
} from "@/api/grammar";

export default {
  name: "textBookList",
  components: { dynamicBox },
  computed: {
    ...mapGetters(["studyStage"]),
  },
  data() {
    return {
      courseInfo: "",
      menuLink: [
        {
          name: "语法学习",
          type: 1,
          url: "/grammar/courseHome/grammarLearnHome",
        },
        {
          name: "自主测试",
          type: 2,
          url: "/grammar/courseHome/independentTestHome",
        },
        // {name: '单元整体回忆', type: 8, url: '/grammar/courseHome/overallMemoryHome'},
        { name: "单元测试", type: 4, url: "/grammar/courseHome/unitTestHome" },
        {
          name: "单元听写",
          type: 5,
          url: "/grammar/courseHome/unitDictationHome",
        },
        {
          name: "语法学习错题本",
          type: 6,
          url: "/grammar/courseHome/wrongTopicHome",
        },
        {
          name: "单元听写错题本",
          type: 7,
          url: "/grammar/courseHome/wrongTopicSpell",
        },
      ],
      windowStatus: false,
      showBookPop: false,
    };
  },
  methods: {
    ...mapMutations(["CHANGE_STUDY_TYPE"]),
    goLink(item) {
      if (this.$route.query.type != item.type) {
        let url = `${item.url}?type=${item.type}&id=${this.$route.query.id}`;
        this.$router.push(url);
      }
    },
    //精准复习
    preciseReview() {
      let params = {
        sign: 4,
        curriculum_id: this.$route.query.id,
        token: Lockr.get("token"),
      };
      preciseIntelligentReview(params).then((res) => {
        let data = {
          title: "精准复习",
          type: "preciseReview/grammarSpell",
          dataSource: res.data,
          courseType: "jzfx", //精准复习
        };
        this.CHANGE_STUDY_TYPE(data);
        this.windowStatus = true;
      });
    },
    //开始对比测试
    startComparision() {
      let id = this.$route.query.id;
      this.$router.push(`/grammar/comparisonTest?id=${id}`);
    },
    //检查本书测试单元是否学习完
    async checkUnitEnd() {
      let params = {
        token: Lockr.get("token"),
        curriculum_id: this.$route.query.id,
      };
      let result = await checkBook(params);
      if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
        this.startBookTest();
      } else {
        this.showBookPop = true;
        setTimeout(() => {
          this.showBookPop = false;
        }, 1000);
      }
    },
    //开始本书测试
    startBookTest() {
      let id = this.$route.query.id;
      this.$router.push(`/grammar/testOption?id=${id}`);
    },
    //开始智能听写
    startAIListen() {
      let params = {
        token: Lockr.get("token"),
        curriculum_id: this.$route.query.id,
      };
      intelligentDictation(params).then((res) => {
        let data = {
          title: "智能听写",
          type: "smartReview/wordSpell",
          dataSource: res.data,
          courseType: "zntx",
        };
        this.CHANGE_STUDY_TYPE(data);
        this.windowStatus = true;
      });
    },
    callBack(data) {
      this.windowStatus = false;
    },
  },
  watch: {
    $route() {
      this.courseInfo = Lockr.get("courseGrammar");
    },
  },
  created() {
    this.courseInfo = Lockr.get("courseGrammar");
    this.courseId = this.$route.query.id;
  },
};
</script>

<style scoped lang='less'>
.text-book {
  flex: 1;
  background: #fff;

  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    padding-left: 10px;
    border-left: 3px solid #333;
  }

  .title-text {
    border: 2px solid #f5a623;
    padding: 12px 17px;
    margin: 20px 10px;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    line-height: 19px;
  }

  .class-btn {
    margin: 20px 10px;
  }
  .lock-unit {
    position: absolute !important;
    top: -35px;
    left: 0px;
    font-size: 14px;
    white-space: nowrap;
    padding: 7px 15px;
    background: #40C2B8;
  }

  .lock-unit:before {
    position: absolute;
    border: 5px solid;
    border-color: #00b29f transparent transparent transparent;
    content: "";
    bottom: -10px;
  }
}

.menu-link {
  border-left: 3px solid #333;
  display: flex;
  align-items: center;
  margin: 20px 0;
  flex-wrap: wrap;

  /*height: 20px;*/

  .title {
    padding: 0 10px;
    margin: 10px 0;
    cursor: pointer;
    font-size: 14px;
  }

  .title:hover {
    color: #469ff2;
  }

  .title:not(:last-child) {
    border-right: 1px solid #333;
  }

  .active-item {
    color: #469ff2;
  }
}
</style>